import React from "react";

export function CVPreview({ data, language }) {
  const L = language === "fr"
    ? { summary: "Profil", experience: "Expérience professionnelle", education: "Formation", skills: "Compétences", languages: "Langues", empty: "Le CV optimisé s'affichera ici après analyse." }
    : { summary: "Profile", experience: "Professional Experience", education: "Education", skills: "Skills", languages: "Languages", empty: "Your optimized resume will appear here after analysis." };

  if (!data) {
    return (
      <div className="a4-page flex items-center justify-center" data-testid="cv-preview-empty">
        <p className="text-sm text-[#6b7280] italic text-center max-w-[60%]">{L.empty}</p>
      </div>
    );
  }

  const h = data.header || {};
  const contact = [h.email, h.phone, h.location, h.linkedin].filter(Boolean).join("  |  ");

  return (
    <div className="a4-page" data-testid="cv-preview">
      <h1>{h.full_name || ""}</h1>
      {h.title && <div className="sub">{h.title}</div>}
      {contact && <div className="contact">{contact}</div>}

      {data.summary && (
        <>
          <div className="a4-section-title">{L.summary}</div>
          <p className="m-0">{data.summary}</p>
        </>
      )}

      {Array.isArray(data.experiences) && data.experiences.length > 0 && (
        <>
          <div className="a4-section-title">{L.experience}</div>
          {data.experiences.map((exp, i) => (
            <div key={i} className="mb-2">
              <div className="flex justify-between items-baseline gap-2">
                <div className="font-semibold">
                  {exp.role}{exp.company ? ` — ${exp.company}` : ""}
                </div>
                <div className="text-[10px] text-[#525252] italic whitespace-nowrap">
                  {[exp.location, [exp.start_date, exp.end_date].filter(Boolean).join(" – ")].filter(Boolean).join(" | ")}
                </div>
              </div>
              {Array.isArray(exp.bullets) && (
                <ul className="list-none pl-3 m-0 mt-1">
                  {exp.bullets.map((b, j) => (
                    <li key={j} className="relative pl-3">
                      <span className="absolute left-0">•</span>{b}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </>
      )}

      {Array.isArray(data.education) && data.education.length > 0 && (
        <>
          <div className="a4-section-title">{L.education}</div>
          {data.education.map((edu, i) => (
            <div key={i} className="mb-1 flex justify-between items-baseline gap-2">
              <div className="font-semibold">{edu.degree}{edu.school ? ` — ${edu.school}` : ""}</div>
              <div className="text-[10px] text-[#525252] italic whitespace-nowrap">
                {[edu.location, edu.year].filter(Boolean).join(" | ")}
              </div>
            </div>
          ))}
        </>
      )}

      {Array.isArray(data.skills) && data.skills.length > 0 && (
        <>
          <div className="a4-section-title">{L.skills}</div>
          <p className="m-0">{data.skills.join("  •  ")}</p>
        </>
      )}

      {Array.isArray(data.languages) && data.languages.length > 0 && (
        <>
          <div className="a4-section-title">{L.languages}</div>
          <p className="m-0">
            {data.languages.map((l) => `${l.name}${l.level ? ` (${l.level})` : ""}`).join("  •  ")}
          </p>
        </>
      )}
    </div>
  );
}
